<template>
    <b-form ref="labelForm" @submit.prevent="submitForm"  v-bind:class="[{ busy: busy}, 'opacity-transition']">
        <pb-spinner v-if="busy"></pb-spinner>
        <b-row align-v="end" v-for="(item, index) in labels" :key="index" class="mt-2">

            <b-col md="4">
                <b-form-group :label="index === 0 ? 'Label count:' : ''" class="mr-2">
                    <b-form-input size="sm" v-model="item.labelCount" class="secondary"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group :label="index === 0 ? 'Article count:' : ''">
                    <b-form-input size="sm" v-model="item.articleCount" class="secondary mr-2"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group>
                    <pb-btn class="w-100" v-if="index !== 0" v-on:click.native="removeLabel(index)"><i
                        class="fal fa-trash-alt"></i> Remove
                    </pb-btn>
                    <pb-btn v-else v-on:click.native="addLabel" class="w-100" variant="primary"><i class="fal fa-plus"></i> Add
                        Label
                    </pb-btn>
                </b-form-group>
            </b-col>
        </b-row>
    </b-form>
</template>

<script>

import {HTTP} from "@shared/_helpers/http";

export default {
    name: 'LabelForm',
    props: {
       supplierId: {
          type: String,
          required: true
       },
        orderPosition: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            busy: false,
            labels: [
                {
                    labelCount: 0,
                    articleCount: 0
                }
            ]
        }
    },
    methods: {
        submit() {
            this.$refs.labelForm.submit();
        },
        addLabel() {
            this.labels.push({
                labelCount: 0,
                articleCount: 0
            });
        },
        removeLabel(index) {
            if (this.labels.length > 1) {
                this.labels.splice(index, 1);
            }
        },
        submitForm(event) {
            this.busy = true;
            event.preventDefault();

            HTTP.post(`/supplier/${this.supplierId}/order/${this.orderPosition.id}/label/${this.orderPosition.sizeId}`, this.labels.filter(label => label.labelCount > 0 && label.articleCount > 0), {
                responseType: 'blob'
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Label_${this.orderPosition.id}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.$emit('submitted');
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.busy = false;
            });
        }
    }
}
</script>

